// The shop's sections for the website's section map (HomePage.vue, owned by
// S1): {type: component}. Each takes the stored section's fields as props
// (v-bind="section") plus what pages.js resolved (items, collection, product,
// moreLink, shop) - see src/server/shop/data.js resolveShopSections.
import {defineAsyncComponent} from "vue";

export const shopSectionComponents = {
    "product-list": defineAsyncComponent(() => import("./ProductListSection.vue")),
    "category-list": defineAsyncComponent(() => import("./CategoryListSection.vue")),
    "featured-picks": defineAsyncComponent(() => import("./FeaturedPicksSection.vue")),
    "collection-spotlight": defineAsyncComponent(() => import("./CollectionSpotlightSection.vue")),
    "live-price": defineAsyncComponent(() => import("./LivePriceSection.vue")),
    "see-in-shop": defineAsyncComponent(() => import("./SeeInShopSection.vue")),
    // A product's or service's reviews on its marketing page (pages.js adds it).
    "product-reviews": defineAsyncComponent(() => import("./ProductReviewsSection.vue")),
};
